import React from 'react';

import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTE } from '@/constants/route';

import styles from './styles.module.css';

interface ContentModalExpiredProposalArbitrageProps {
  closeExpiredProposalModal: () => void;
}

export const ContentModalExpiredProposalArbitrage: React.FC<ContentModalExpiredProposalArbitrageProps> = ({
  closeExpiredProposalModal,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const chatButtons = [
    {
      className: 'card-button-chat-indisponible',
      style: { display: 'block' },
      onClick: () => navigate(ROUTE.HELP),
    },
    {
      className: 'card-button-chat-disponible',
      style: { display: 'none' },
      onClick: () => closeExpiredProposalModal(),
    },
  ];

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('expiredProposalModal.title')}</h2>
      <p className={styles.description}>{t('expiredProposalModal.description')}</p>
      <p>{t('expiredProposalModal.contactAdvisorText')}</p>
      <div className={styles.actions}>
        {chatButtons.map(({ className, style, onClick }) => (
          <MtxButton
            key={className}
            className={className}
            style={style}
            variant="primary"
            size="large"
            onClick={onClick}
          >
            {t('expiredProposalModal.contactAdvisorButton')}
          </MtxButton>
        ))}
      </div>
    </div>
  );
};
